import vendorDashboardAPI from '@/utils/api/vendorDashboard';
import {
  genericError,
  invitationDeleteSuccess,
  inviteSuccess,
  emailError,
} from '@/utils/alerts.service';
import router from '@/router/dashboard.js';

/*
  This is the detail view of an invitation that has already been sent and shows up in the table
*/
export const agencyInvitation = {
  namespaced: true,
  state: {
    invitation: {},
  },
  getters: {
    getInvitation(state) {
      return state.invitation;
    },
  },
  mutations: {
    setInvitationData(state, data) {
      state.invitation = data;
    },
  },
  actions: {
    async fetchInvitationData({ dispatch, commit }, id) {
      return vendorDashboardAPI
        .getInvitationDetail(id)
        .then(data => {
          commit('setInvitationData', data);
        })
        .catch(() => {
          dispatch('showUserMessage', { ...genericError }, { root: true });
        });
    },

    async deleteInvitation({ dispatch }, id) {
      return vendorDashboardAPI
        .deleteInvitation(id)
        .then(() => {
          dispatch(
            'showUserMessage',
            { ...invitationDeleteSuccess },
            { root: true }
          );
          router.push('/partners');
        })
        .catch(() => {
          dispatch('showUserMessage', { ...genericError }, { root: true });
        });
    },

    async resendPartnerInvite({ dispatch }, email) {
      const data = {
        email: email,
      };

      return vendorDashboardAPI
        .resendInvite(data)
        .then(() => {
          dispatch('showUserMessage', { ...inviteSuccess }, { root: true });
          router.push('/partners');
        })
        .catch(() => {
          dispatch('showUserMessage', { ...emailError }, { root: true });
        });
    },
  },
};
